import { gql } from '@apollo/client';

export const USER_SIGNUP = gql`
  mutation UserRegistration($input: UserRegistrationInput!) {
    userRegistration(input: $input)
  }
`;
